(function() {
  function boot() {
    initPriceEditor();
    initExportFormatBuilder();
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
    document.addEventListener('turbolinks:load', fn);
    document.addEventListener('turbo:load', fn);
  }

  function initPriceEditor() {
    var container = document.querySelector('.pl-admin[data-page="price-list-edit-entries"]');
    if (!container || container.dataset.jsBound === 'true') return;
    container.dataset.jsBound = 'true';

    function selectedRows() {
      return Array.prototype.slice.call(container.querySelectorAll('.js-row-select:checked')).map(function(cb) {
        return cb.closest('tr');
      });
    }

    ['retail', 'wholesale', 'webshop'].forEach(function(priceType) {
      var headerField = container.querySelector('#header-price-' + priceType);
      if (!headerField) return;

      // Apply to selected rows on blur (existing functionality)
      headerField.addEventListener('blur', function() {
        if (headerField.value === '') return;
        selectedRows().forEach(function(row) {
          var input = row.querySelector('.js-field-price-' + priceType);
          if (input) input.value = headerField.value;
        });
      });

      // Apply button for each price type
      var applyBtn = container.querySelector('#apply-selected-' + priceType);
      if (applyBtn) {
        applyBtn.addEventListener('click', function() {
          if (headerField.value === '') {
            alert('Voer eerst een waarde in.');
            headerField.focus();
            return;
          }
          var rows = selectedRows();
          if (rows.length === 0) {
            alert('Selecteer eerst een of meer rijen.');
            return;
          }
          rows.forEach(function(row) {
            var input = row.querySelector('.js-field-price-' + priceType);
            if (input) input.value = headerField.value;
          });
        });
      }
    });

    var selectAllCb = container.querySelector('#bulk-row-select-all');
    var rowCheckboxes = container.querySelectorAll('.js-row-select');
    var removeBtn = container.querySelector('#remove-products-btn');
    var removeProductIds = container.querySelector('#remove-product-ids');
    var removeProductsForm = container.querySelector('#remove-products-form');

    function updateRemoveButton() {
      var checked = Array.prototype.slice.call(container.querySelectorAll('.js-row-select:checked'));
      var ids = checked.map(function(cb) { return cb.getAttribute('data-product-id'); }).filter(Boolean);
      if (removeProductIds) removeProductIds.value = ids.join(',');
      if (removeBtn) {
        removeBtn.disabled = ids.length === 0;
        // Update confirm message with count
        if (ids.length > 0) {
          removeBtn.setAttribute('data-confirm', 'Weet je zeker dat je ' + ids.length + ' geselecteerde product(en) wilt verwijderen uit de prijslijst?');
        }
      }
      
      // Update save selected button state
      var saveSelectedBtn = container.querySelector('#save-selected-btn');
      if (saveSelectedBtn) {
        saveSelectedBtn.disabled = ids.length === 0;
      }
    }

    // Add explicit confirm handler for remove products form
    if (removeProductsForm && removeBtn) {
      removeProductsForm.addEventListener('submit', function(e) {
        // Get current product IDs from hidden field
        var productIdsValue = removeProductIds ? removeProductIds.value : '';
        var productIds = productIdsValue.split(',').filter(function(id) { return id.trim() !== ''; });
        
        if (productIds.length === 0) {
          e.preventDefault();
          alert('Selecteer eerst een of meer producten om te verwijderen.');
          return false;
        }
        
        var count = productIds.length;
        var confirmMessage = 'Weet je zeker dat je ' + count + ' geselecteerde product(en) wilt verwijderen uit de prijslijst?';
        
        if (!confirm(confirmMessage)) {
          e.preventDefault();
          return false;
        }
        
        // Ensure product_ids is set correctly before submit
        if (removeProductIds) {
          removeProductIds.value = productIds.join(',');
        }
        
        // Get current URL parameters and set them in hidden fields
        var urlParams = new URLSearchParams(window.location.search);
        var productGroupIdField = removeProductsForm.querySelector('input[name="product_group_id"]');
        var productGroupSizeIdField = removeProductsForm.querySelector('input[name="product_group_size_id"]');
        var pageField = removeProductsForm.querySelector('input[name="page"]');
        
        if (productGroupIdField && urlParams.has('product_group_id')) {
          productGroupIdField.value = urlParams.get('product_group_id');
        }
        if (productGroupSizeIdField && urlParams.has('product_group_size_id')) {
          productGroupSizeIdField.value = urlParams.get('product_group_size_id');
        }
        if (pageField && urlParams.has('page')) {
          pageField.value = urlParams.get('page');
        }
      });
    }

    if (selectAllCb) {
      selectAllCb.addEventListener('change', function() {
        Array.prototype.forEach.call(rowCheckboxes, function(cb) {
          cb.checked = selectAllCb.checked;
        });
        updateRemoveButton();
      });
    }

    Array.prototype.forEach.call(rowCheckboxes, function(cb) {
      cb.addEventListener('change', updateRemoveButton);
    });
    updateRemoveButton();

    // Save selected rows only
    var saveSelectedBtn = container.querySelector('#save-selected-btn');
    var bulkUpdateForm = container.querySelector('#bulk-update-form');
    
    if (saveSelectedBtn && bulkUpdateForm) {
      saveSelectedBtn.addEventListener('click', function() {
        var checked = Array.prototype.slice.call(container.querySelectorAll('.js-row-select:checked'));
        if (checked.length === 0) {
          alert('Selecteer eerst een of meer rijen om op te slaan.');
          return;
        }
        
        // Build entries object with only selected rows
        var entries = {};
        checked.forEach(function(cb) {
          var productId = cb.getAttribute('data-product-id');
          if (!productId) return;
          
          var row = cb.closest('tr');
          var retailInput = row.querySelector('.js-field-price-retail');
          var wholesaleInput = row.querySelector('.js-field-price-wholesale');
          var webshopInput = row.querySelector('.js-field-price-webshop');
          
          entries[productId] = {};
          if (retailInput && retailInput.value !== '') {
            entries[productId].price_retail = retailInput.value;
          }
          if (wholesaleInput && wholesaleInput.value !== '') {
            entries[productId].price_wholesale = wholesaleInput.value;
          }
          if (webshopInput && webshopInput.value !== '') {
            entries[productId].price_webshop = webshopInput.value;
          }
        });
        
        // Disable button during submission
        saveSelectedBtn.disabled = true;
        saveSelectedBtn.textContent = 'Bezig met opslaan...';
        
        // Submit via AJAX
        var formAction = bulkUpdateForm.getAttribute('action');
        var formMethod = bulkUpdateForm.getAttribute('method') || 'POST';
        var csrfToken = document.querySelector('meta[name="csrf-token"]');
        var token = csrfToken ? csrfToken.getAttribute('content') : '';
        
        var formData = new FormData();
        Object.keys(entries).forEach(function(productId) {
          Object.keys(entries[productId]).forEach(function(field) {
            formData.append('price_list_entries[' + productId + '][' + field + ']', entries[productId][field]);
          });
        });
        
        // Use fetch API for AJAX submission
        fetch(formAction, {
          method: formMethod === 'PATCH' ? 'POST' : formMethod,
          headers: {
            'X-CSRF-Token': token,
            'X-HTTP-Method-Override': 'PATCH'
          },
          body: formData
        })
        .then(function(response) {
          if (response.redirected) {
            window.location.href = response.url;
          } else {
            return response.text().then(function(text) {
              window.location.reload();
            });
          }
        })
        .catch(function(error) {
          console.error('Error:', error);
          alert('Er is een fout opgetreden bij het opslaan.');
          saveSelectedBtn.disabled = false;
          saveSelectedBtn.textContent = 'Sla Geselecteerde Op';
        });
      });
    }

    // Update all filtered records
    var updateFilteredBtn = container.querySelector('#update-filtered-btn');
    var updateFilteredForm = container.querySelector('#update-filtered-form');
    var filteredPriceRetail = container.querySelector('#filtered-price-retail');
    var filteredPriceWholesale = container.querySelector('#filtered-price-wholesale');
    var filteredPriceWebshop = container.querySelector('#filtered-price-webshop');
    var headerPriceRetail = container.querySelector('#header-price-retail');
    var headerPriceWholesale = container.querySelector('#header-price-wholesale');
    var headerPriceWebshop = container.querySelector('#header-price-webshop');
    
    if (updateFilteredBtn && updateFilteredForm) {
      updateFilteredForm.addEventListener('submit', function(e) {
        // Check if at least one price is provided
        var hasRetail = headerPriceRetail && headerPriceRetail.value !== '';
        var hasWholesale = headerPriceWholesale && headerPriceWholesale.value !== '';
        var hasWebshop = headerPriceWebshop && headerPriceWebshop.value !== '';
        
        if (!hasRetail && !hasWholesale && !hasWebshop) {
          e.preventDefault();
          alert('Voer minimaal één prijs in de header velden in.');
          return false;
        }
        
        // Copy header values to hidden fields
        if (filteredPriceRetail && headerPriceRetail) {
          filteredPriceRetail.value = headerPriceRetail.value || '';
        }
        if (filteredPriceWholesale && headerPriceWholesale) {
          filteredPriceWholesale.value = headerPriceWholesale.value || '';
        }
        if (filteredPriceWebshop && headerPriceWebshop) {
          filteredPriceWebshop.value = headerPriceWebshop.value || '';
        }
        
        // Form will submit normally
        return true;
      });
    }

    var adjustmentType = container.querySelector('#adjustment_type');
    var adjustmentValue = container.querySelector('#adjustment_value');
    var valueHelp = container.querySelector('#value-help');
    var bulkAdjustBtn = container.querySelector('#bulk-adjust-btn');
    var bulkPriceType = container.querySelector('#bulk-price-type');

    if (adjustmentType && adjustmentValue && valueHelp) {
      adjustmentType.addEventListener('change', function() {
        if (adjustmentType.value === 'percentage') {
          valueHelp.textContent = 'Voor percentage: 10 = +10%, -5 = -5%';
          adjustmentValue.placeholder = '10 voor +10%';
        } else {
          valueHelp.textContent = 'Voor vaste waarde: bedrag in euro (bijv. 15.50)';
          adjustmentValue.placeholder = '15.50 voor €15,50';
        }
      });
    }

    // Bulk adjust prices - only update inputs on screen
    if (bulkAdjustBtn && adjustmentType && adjustmentValue && bulkPriceType) {
      bulkAdjustBtn.addEventListener('click', function() {
        var priceType = bulkPriceType.value;
        var adjType = adjustmentType.value;
        var adjValue = parseFloat(adjustmentValue.value);
        
        if (isNaN(adjValue) || adjValue === 0) {
          alert('Voer een geldige waarde in.');
          adjustmentValue.focus();
          return;
        }
        
        // Get all price input fields
        var priceFields = [];
        if (priceType === 'retail' || priceType === 'all') {
          priceFields = priceFields.concat(Array.prototype.slice.call(container.querySelectorAll('.js-field-price-retail')));
        }
        if (priceType === 'wholesale' || priceType === 'all') {
          priceFields = priceFields.concat(Array.prototype.slice.call(container.querySelectorAll('.js-field-price-wholesale')));
        }
        if (priceType === 'webshop' || priceType === 'all') {
          priceFields = priceFields.concat(Array.prototype.slice.call(container.querySelectorAll('.js-field-price-webshop')));
        }
        
        // Update each field
        priceFields.forEach(function(field) {
          var currentValue = parseFloat(field.value);
          if (isNaN(currentValue) || currentValue === 0) {
            return; // Skip empty fields
          }
          
          var newValue;
          if (adjType === 'percentage') {
            // Percentage adjustment: new = current * (1 + percentage/100)
            newValue = currentValue * (1 + adjValue / 100);
          } else {
            // Absolute adjustment: new = current + adjustment
            newValue = currentValue + adjValue;
          }
          
          // Round to 2 decimal places
          newValue = Math.round(newValue * 100) / 100;
          
          // Update the field
          field.value = newValue.toFixed(2);
          
          // Trigger change event to mark field as changed
          field.dispatchEvent(new Event('change', { bubbles: true }));
        });
        
        // Visual feedback: make button blink
        if (priceFields.length > 0) {
          bulkAdjustBtn.classList.add('btn-success');
          bulkAdjustBtn.classList.remove('btn-warning');
          bulkAdjustBtn.style.transition = 'all 0.3s ease';
          
          // Blink animation
          var blinkCount = 0;
          var blinkInterval = setInterval(function() {
            if (blinkCount < 3) {
              bulkAdjustBtn.style.opacity = bulkAdjustBtn.style.opacity === '0.5' ? '1' : '0.5';
              blinkCount++;
            } else {
              clearInterval(blinkInterval);
              bulkAdjustBtn.style.opacity = '1';
              setTimeout(function() {
                bulkAdjustBtn.classList.remove('btn-success');
                bulkAdjustBtn.classList.add('btn-warning');
              }, 500);
            }
          }, 200);
        }
      });
    }

    // Reset prices to original values
    var resetPricesBtn = container.querySelector('#reset-prices-btn');
    if (resetPricesBtn) {
      resetPricesBtn.addEventListener('click', function() {
        if (!confirm('Weet je zeker dat je alle prijzen wilt resetten naar de originele waarden?')) {
          return;
        }
        
        // Get all price input fields
        var allPriceFields = Array.prototype.slice.call(container.querySelectorAll('.js-field-price-retail, .js-field-price-wholesale, .js-field-price-webshop'));
        
        var resetCount = 0;
        allPriceFields.forEach(function(field) {
          var originalValue = field.getAttribute('data-original-value');
          if (originalValue !== null) {
            field.value = originalValue === '' ? '' : parseFloat(originalValue).toFixed(2);
            field.dispatchEvent(new Event('change', { bubbles: true }));
            resetCount++;
          }
        });
        
        // Visual feedback: make button blink
        resetPricesBtn.classList.add('btn-success');
        resetPricesBtn.classList.remove('btn-default');
        resetPricesBtn.style.transition = 'all 0.3s ease';
        
        var blinkCount = 0;
        var blinkInterval = setInterval(function() {
          if (blinkCount < 3) {
            resetPricesBtn.style.opacity = resetPricesBtn.style.opacity === '0.5' ? '1' : '0.5';
            blinkCount++;
          } else {
            clearInterval(blinkInterval);
            resetPricesBtn.style.opacity = '1';
            setTimeout(function() {
              resetPricesBtn.classList.remove('btn-success');
              resetPricesBtn.classList.add('btn-default');
            }, 500);
          }
        }, 200);
      });
    }

    // Dynamic product group size filter update
    var productGroupFilter = container.querySelector('#product_group_filter');
    var productGroupSizeFilter = container.querySelector('#product_group_size_filter');
    var priceListId = container.closest('.pl-admin') ? container.closest('.pl-admin').getAttribute('data-price-list-id') : null;
    
    if (!priceListId && window.location.pathname) {
      // Extract price list ID from URL: /admin/price_lists/:id/edit_entries
      var match = window.location.pathname.match(/\/admin\/price_lists\/(\d+)\//);
      if (match) {
        priceListId = match[1];
      }
    }

    function updateProductGroupSizes() {
      if (!productGroupFilter || !productGroupSizeFilter || !priceListId) return;
      
      var selectedGroupId = productGroupFilter.value;
      // Always include subgroups (default behavior)
      var includeSubgroups = true;
      
      // Store current selection
      var currentSizeId = productGroupSizeFilter.value;
      
      // Disable dropdown while loading
      productGroupSizeFilter.disabled = true;
      productGroupSizeFilter.innerHTML = '<option value="">Laden...</option>';
      
      // Build URL
      var url = '/admin/price_lists/' + priceListId + '/product_group_sizes';
      var params = new URLSearchParams();
      if (selectedGroupId) {
        params.append('product_group_id', selectedGroupId);
      }
      params.append('include_subgroups', 'true');
      
      if (params.toString()) {
        url += '?' + params.toString();
      }
      
      // Fetch sizes
      fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(function(data) {
        // Clear dropdown
        productGroupSizeFilter.innerHTML = '<option value="">Alle groottes</option>';
        
        // Add sizes
        if (data.sizes && data.sizes.length > 0) {
          data.sizes.forEach(function(size) {
            var option = document.createElement('option');
            option.value = size.id;
            option.textContent = size.display_name;
            productGroupSizeFilter.appendChild(option);
          });
          
          // Restore selection if it still exists
          if (currentSizeId) {
            var optionExists = Array.prototype.some.call(productGroupSizeFilter.options, function(opt) {
              return opt.value === currentSizeId;
            });
            if (optionExists) {
              productGroupSizeFilter.value = currentSizeId;
            }
          }
        }
        
        productGroupSizeFilter.disabled = false;
      })
      .catch(function(error) {
        console.error('Error loading product group sizes:', error);
        productGroupSizeFilter.innerHTML = '<option value="">Fout bij laden</option>';
        productGroupSizeFilter.disabled = false;
      });
    }

    // Listen to product group changes
    if (productGroupFilter) {
      productGroupFilter.addEventListener('change', updateProductGroupSizes);
    }
  }

  function initExportFormatBuilder() {
    var container = document.querySelector('.pl-admin[data-page="price-list-export-format-form"]');
    if (!container || container.dataset.jsBound === 'true') return;
    container.dataset.jsBound = 'true';

    var list = container.querySelector('#columns-list');
    var select = container.querySelector('#available-columns-select');
    var addBtn = container.querySelector('#add-column-btn');
    if (!list || !select || !addBtn) return;

    function updateOrders() {
      Array.prototype.forEach.call(list.querySelectorAll('.pl-column-item'), function(item, index) {
        var orderInput = item.querySelector('.column-order');
        if (orderInput) orderInput.value = index;
      });
    }

    function addOptionToSelect(key, label, category) {
      var option = document.createElement('option');
      option.value = key;
      option.textContent = label;
      option.setAttribute('data-label', label);
      option.setAttribute('data-category', category || '');

      var optgroups = select.querySelectorAll('optgroup');
      var target = null;
      Array.prototype.forEach.call(optgroups, function(group) {
        if (group.getAttribute('data-category') === (category || '')) target = group;
      });

      if (target) {
        target.appendChild(option);
      } else {
        select.appendChild(option);
      }
    }

    function buildColumnItem(key, label, category) {
      var item = document.createElement('div');
      item.className = 'pl-column-item js-column-item';
      item.setAttribute('data-column-key', key);
      item.setAttribute('data-column-category', category || '');
      item.setAttribute('draggable', 'true');

      item.innerHTML = '' +
        '<span class="pl-column-handle" title="Versleep om volgorde te wijzigen">☰</span>' +
        '<div class="pl-column-meta">' + key + '</div>' +
        '<input type="hidden" name="price_list_export_format[columns][][key]" class="column-key" value="' + key + '">' +
        '<input type="hidden" name="price_list_export_format[columns][][order]" class="column-order" value="0">' +
        '<input type="text" name="price_list_export_format[columns][][label]" class="form-control column-label" value="' + label + '" placeholder="Kolom label" style="flex:1; min-width:160px;">' +
        '<button type="button" class="btn btn-danger btn-xs js-remove-column">Verwijder</button>';

      return item;
    }

    addBtn.addEventListener('click', function() {
      var option = select.options[select.selectedIndex];
      if (!option || !option.value) return;

      var key = option.value;
      var label = option.getAttribute('data-label') || option.text;
      var category = option.getAttribute('data-category') || '';
      var item = buildColumnItem(key, label, category);
      list.appendChild(item);
      option.remove();
      select.value = '';
      updateOrders();
    });

    container.addEventListener('click', function(event) {
      var removeBtn = event.target.closest('.js-remove-column');
      if (!removeBtn) return;
      var item = removeBtn.closest('.pl-column-item');
      if (!item) return;

      var key = item.getAttribute('data-column-key');
      var category = item.getAttribute('data-column-category') || '';
      var labelInput = item.querySelector('.column-label');
      var label = labelInput && labelInput.value ? labelInput.value : key;

      addOptionToSelect(key, label, category);
      item.remove();
      updateOrders();
    });

    var dragItem = null;

    list.addEventListener('dragstart', function(event) {
      var item = event.target.closest('.pl-column-item');
      if (!item) return;
      dragItem = item;
      item.classList.add('dragging');
      event.dataTransfer.effectAllowed = 'move';
    });

    list.addEventListener('dragend', function(event) {
      var item = event.target.closest('.pl-column-item');
      if (item) item.classList.remove('dragging');
      dragItem = null;
      updateOrders();
    });

    list.addEventListener('dragover', function(event) {
      event.preventDefault();
      var target = event.target.closest('.pl-column-item');
      if (!dragItem || !target || target === dragItem) return;
      var rect = target.getBoundingClientRect();
      var before = event.clientY < rect.top + rect.height / 2;
      if (before) {
        list.insertBefore(dragItem, target);
      } else {
        list.insertBefore(dragItem, target.nextSibling);
      }
    });

    updateOrders();
  }

  onReady(boot);
})();
